import React, { useState } from "react";
import './MoveItemModal.css';

const MoveItemModal = ({ item, onClose, onConfirm }) => {
  const [selectedCategory, setSelectedCategory] = useState("");

  if (!item || !item.__typename) return null;

  const currentSection = item.__typename.replace("Fix", "");
  const options =
    currentSection === "Supplies"
      ? [{ value: "generalInventory", label: "Other Equipment" }]
      : [{ value: "supplies", label: "Office Supplies" }];


  const handleSubmit = () => {

    if (!selectedCategory) {
      alert("Please select the category");
      return;
    }
    onConfirm(item,selectedCategory);
    onClose();

  };

  return (
    <div className="move-overlay" onDoubleClick={(e) => {
      if (e.target.classList.contains("move-overlay")) {
        onClose();
      }
    }}>
      <div className="move-content">
        <h2 className="move-title">Move to another section</h2>

        <div className="move-select-group">
          <label htmlFor="category-select">Select new category:</label>
          <select
            id="category-select"
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
          >
            <option value="" disabled hidden>
              -- Select a category --
            </option>
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>

        </div>
          <div className="move-actions">
            <button className="move-cancel" onClick={onClose}>
              Cancel
            </button>
            <button
              className="move-confirm"
              onClick={handleSubmit}
              disabled={!selectedCategory}
            >
              Confirm
            </button>
          </div>
        

      </div>
    </div>
  );
};

export default MoveItemModal;


